import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { MatBadgeModule } from "@angular/material/badge"
import { MatButtonModule } from "@angular/material/button"
import { MatCardModule } from "@angular/material/card"
import { MatDialogModule } from "@angular/material/dialog"
import { MatIconModule } from "@angular/material/icon"
import { MatInputModule } from "@angular/material/input"
import { MatListModule } from "@angular/material/list"
import { MatMenuModule } from "@angular/material/menu"
import { MatRadioModule } from "@angular/material/radio"
import { MatSelectModule } from "@angular/material/select"
import { MatSidenavModule } from "@angular/material/sidenav"
import { MatSlideToggleModule } from "@angular/material/slide-toggle"
import { MatTreeModule } from "@angular/material/tree"
import { RouterModule } from "@angular/router"

import { ClientLayoutComponent, ClientSidebarComponent } from "./client"
import { FilterComponent } from "./filter/filter.component"
import { FooterComponent } from "./footer/footer.component"
import { HeaderModule } from "./header/header.module"
import { LayoutComponent } from "./layout/layout.component"
import { ChatPopupComponent } from "./popups/chat-popup/chat-popup.component"
import { DeletePopupComponent } from "./popups/delete-popup/delete-popup.component"
import { SettingsMenuAppComponent } from "./settings-menu/settings-menu.component"
import { SidebarComponent } from "./sidebar/sidebar.component"
import { BreadcrumbComponent, SettingsMenuComponent } from "./ui-elements"
import { ExpandoButtonComponent } from "./ui-elements/expando-button/expando-button.component"
import { FileUploaderComponent } from "./uploaders/file-uploader/file-uploader.component"
import { ImageUploaderComponent } from "./uploaders/image-uploader/image-uploader.component"

@NgModule({
  declarations: [
    SidebarComponent,
    FooterComponent,
    LayoutComponent,
    BreadcrumbComponent,
    SettingsMenuAppComponent,
    ImageUploaderComponent,
    FileUploaderComponent,
    DeletePopupComponent,
    FilterComponent,
    SettingsMenuComponent,
    ChatPopupComponent,
    ExpandoButtonComponent,
    ClientLayoutComponent,
    ClientSidebarComponent
  ],
  imports: [
    HeaderModule,
    ReactiveFormsModule,
    MatListModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    CommonModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    MatSidenavModule,
    MatTreeModule,
    MatBadgeModule,
    MatCardModule,
    MatDialogModule,
    MatInputModule,
    MatRadioModule,
    MatSlideToggleModule
    // NgSelectModule
  ],
  exports: [
    HeaderModule,
    SidebarComponent,
    FooterComponent,
    LayoutComponent,
    BreadcrumbComponent,
    ImageUploaderComponent,
    FileUploaderComponent,
    DeletePopupComponent,
    FilterComponent,
    SettingsMenuComponent,
    ExpandoButtonComponent
  ]
})
export class SharedModule {}
